/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Step_3Inputs */

const en_svc_integration_step_3 = /** @type {(inputs: Svc_Integration_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build the integration with validation, so bad output never reaches your records.`)
};

const lv_svc_integration_step_3 = /** @type {(inputs: Svc_Integration_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidojam integrāciju ar validāciju, lai kļūdains rezultāts nenonāktu Jūsu ierakstos.`)
};

/**
* | output |
* | --- |
* | "Build the integration with validation, so bad output never reaches your records." |
*
* @param {Svc_Integration_Step_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_step_3 = /** @type {((inputs?: Svc_Integration_Step_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Step_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_step_3(inputs)
	return en_svc_integration_step_3(inputs)
});